<template>
  <div :class="type === 'error' ? 'error-msg-con' : 'success-msg-con'">
    <svg v-if="type === 'error'" height="18" width="18" class="t-icon info-outline"></svg>
    <p class="message">{{ message }}</p>
  </div>
</template>
<script>
  export default {
    name: 'ErrorNotification',
    props: {
      message: {
        type: String,
        default: '',
      },
      type: {
        type: String,
        default: 'error',
        validator(value) {
          return ['success', 'error'].includes(value)
        }
      }
    },
    data() {
      return {
        cdn_url: window.APP_CONFIG.CDN_URL
      }
    },
  }
</script>
<style lang="scss" scoped>
  .error-msg-con {
    .t-icon {
      background-color: #E8465A;
      margin-right: 6px;
    }
    p {
      margin: 0;
      flex-basis: 97%;
    }
  }
</style>